import './Announcements.scss';
import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { Modal, Icon, AlertMessage } from '@gplibraries/react/components';
import {
  useLocalStorage,
  useConfig,
  useTokenProvider,
} from '@gplibraries/react/hooks';
import { fetchActiveAnnouncements } from '../../api/announcements.js';
import DOMPurify from 'dompurify';
import parse from 'html-react-parser';

export default function Announcements() {

  const { dealerAccessApiScope, dealerAccessApiHost } = useConfig();
  const [viewed, setViewed] = useLocalStorage('lpda_viewed_announcements', []);
  const [showModal, setShowModal] = useState(false);
  const getToken = useTokenProvider({ scopes: [dealerAccessApiScope]});

  const { isLoading: loading, error, data: announcements } = useQuery({
    enabled: Boolean(getToken),
    queryKey: ['announcements','active'],
    queryFn: () => getToken()
      .then((resolvedToken) => fetchActiveAnnouncements(dealerAccessApiHost, resolvedToken.accessToken))
      .then(data => data.json()),
  })

  let formatDate = (isoString) => {
    if (!isoString) return '';
    let options = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    }
    return (new Date(isoString)).toLocaleDateString('en-US', options);
  }

  if (error) console.error(error);
  if (loading) return;

  return (<>
    {announcements?.data?.length > 0 && <>

      <AlertMessage className={'flex-row middle'} type={'color'}>
        <Icon glyph={'megaphone-fill xl'}/>
        <button className={'text-only bold'} onClick={() => setShowModal(true)}>
          {announcements.data.length} announcement{announcements.data.length > 1 && 's'}
        </button>
      </AlertMessage>

      <Modal show={showModal} className={'block medium'}>
        <div className="flex-col full announcements-container stretch">

          <div className="flex-row space top heading">
            <div className="flex-row middle">
              <Icon glyph={'megaphone-fill'}/>
              <h1>Announcements</h1>
            </div>
            <button className="icon-only" onClick={() => setShowModal(false)}>
              <Icon glyph={'x-lg'}/>
            </button>
          </div>

          <div className="flex-col announcements-wrapper">

            {announcements.data.map(item => {
              // show announcements on page load if one hasn't been viewed yet
              if (!viewed.includes(item.id)) {
                setViewed([...viewed, item.id]);
                setShowModal(true);
              }
              return (
                <div className={'announcement flex-col full'} key={item.id}>

                  <div className="announcement-heading flex-row middle full space">
                    <h2>{item.title}</h2>
                    <span className={'publish-date'}>
                      {item?.field_start_date
                        ? formatDate(item?.field_start_date)
                        : formatDate(item?.created)
                      }
                    </span>
                  </div>

                  <div className="announcement-content">
                    {parse(DOMPurify.sanitize(item.body?.value))}
                  </div>

                </div>
              )}
            )}

          </div>

        </div>
      </Modal>

    </>}
  </>);
}